import React from 'react'

import ficha from './../../../UI/canvas/FichaTecnica/ficha.svg'
import close from './../../../UI/canvas/FichaTecnica/close.svg'
import { fichasData} from '../../../data/fichas.data'

interface Props{
    isFichaOpened: boolean
    handleFichaViewOnline: any,
    contextualMenu: boolean,
    handleCloseFichas: any,
    individualSelected: string
}

interface State{}

class FichaBriefMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {}
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isFichaOpened && this.props.contextualMenu ? 'ficha-brief-main-mobile fade-in':'ficha-brief-main-mobile fade-out'}>
                <img className='close-btn-fichas-mobile' src={close} onClick = {() => {this.props.handleCloseFichas()}}></img>
                <div className='custom-ficha-hr-mobile'/>
                <div className='main-ficha-title-mobile'>Ficha Técnica</div>
                <img src={ficha} className='fichas-img-mobile'/>
                <div className='main-ficha-text-mobile'>
                    Contamos con un documento personalizado con toda la 
                    información que necesitas. Puedes descargarlo.
                </div>
                <div className='btn-ficha-mobile'>
                        <a href={this.props.individualSelected && fichasData()[0][this.props.individualSelected] ? fichasData()[0][this.props.individualSelected]:""} download>
                            Descargar
                        </a>
                </div>
            </div>
        )
    }
}

export default FichaBriefMobile